import axios, { AxiosResponse, AxiosRequestConfig } from "axios"
import { apiRequest } from "store/Misc/apiRequest"

interface UploadFileArgs {
  name?: string
  file: File | Blob
  mediaId: number | string
  type: "movie" | "artwork" | "trailer" | 'episode'
  onProgress?: (progress: { loaded: number; total?: number; percent?: number }) => void
  signal?: AbortSignal
}

export async function uploadFile({
  name = "file",
  file,
  mediaId,
  type,
  onProgress,
  signal
}: UploadFileArgs): Promise<{ response: AxiosResponse; key?: string } | undefined> {
  try {
    const presign = await apiRequest({
      method: "get",
      url: `/entertainment/movie-box/medias/${mediaId}/upload-url`,
      params: { type, name }
    })

    const url = presign?.data?.url
    if (!url) throw new Error("PRESIGN_URL_MISSING")

    const headers = {
      "Content-Type": (file as File)?.type || "application/octet-stream",
      "x-amz-acl": "public-read"
    }

    const config: AxiosRequestConfig = {
      headers,
      signal,
      onUploadProgress: (evt) => {
        const percent = evt.total ? Math.round((evt.loaded / evt.total) * 100) : undefined
        onProgress?.({ loaded: evt.loaded, total: evt.total, percent })
      }
    }

    const response = await axios.put(url, file, config)
    return { response, key: presign?.data?.key }
  } catch (error) {
    console.error("Upload error:", error)
    throw error
  }
}
